<h1 mat-dialog-title>KESSDI Debugging Info</h1>
<mat-dialog-content>
    <div><strong>Version: </strong>{{ Info?.KESSDIVersion }}</div>
    <div><strong>Build Time: </strong>{{ Info?.BuildTime }}</div>
    <div><strong>Operating Environment: </strong>{{ Info?.Environment }}</div>
    <div><strong>Main Database: </strong>{{ Info?.DBServer }}</div>
    <div><strong>Email Database: </strong>{{ Info?.EmailDBServer }}</div>
    <div><strong>Running on server: </strong>{{ Info?.MachineName }}</div>
    <div><strong>Server IP: </strong>{{ Info?.ServerIPAddress }}</div>
</mat-dialog-content>
